import React from 'react'
import { Pagination} from "@material-ui/lab"
import { createTheme, ThemeProvider, makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  ul: {
    "& .MuiPaginationItem-root": {
      color: "#fff"
    }
  },
  li: {
    fontSize: "1.1rem"
  }
})

const CustomPagination = ({setPage, numOfPages=10}) => {
  const classes = useStyles()



  const handlePageChange = (page) => {
    setPage(page)
    window.scroll(0, 0)
  }

  return (
    <div style={{margin:"20px 10px"}}>
      {/* ThemeProvider - provide dark or light theme */}
      <ThemeProvider > 
        {/* {console.log()} */}
        <Pagination count={numOfPages} color='primary'
          classes={{ul: classes.ul}} size="large"
          onChange={(e) => handlePageChange(e.target.textContent)}
        />
      </ThemeProvider>
    </div>
  )
}

export default CustomPagination
